import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { FC } from 'react';
import { useRecoilValue } from 'recoil';

import {
  borderB,
  borderClassName,
  borderColorClassName,
  borderR,
  borderT,
  headerHeight,
} from '@/components/Subscription/PlanTable';
import {
  columnWidth,
  columnWidthSmall,
  getStructuredPlanData,
  SubscriptionButtonTitle,
} from '@/components/Subscription/PlanTable/Columns';
import Cell from '@/components/Subscription/PlanTable/Columns/Cell';
import H1Cell from '@/components/Subscription/PlanTable/Columns/H1Cell';
import H2Cell from '@/components/Subscription/PlanTable/Columns/H2Cell';
import HeaderCell from '@/components/Subscription/PlanTable/Columns/HeaderCell';
import MainHCell from '@/components/Subscription/PlanTable/Columns/MainHCell';

import { user } from '@/atoms/user';
import { getSubPlanName } from '@/pages/gems-transactions';
import { IPlan, PlanNameEnum } from '@/utils/interfaces/Subscription';
interface Props {
  plans?: IPlan[];
  setSelectedPlan: React.Dispatch<React.SetStateAction<IPlan | undefined>>;
  subscriptionHandle: (buttonTitle: SubscriptionButtonTitle) => Promise<void>;
}
const SingleColumn: FC<Props> = ({
  plans,
  setSelectedPlan,
  subscriptionHandle,
}) => {
  const screens = useBreakpoint();
  const plPlan = plans?.find((i) => i.name === PlanNameEnum.Plus);
  const userState = useRecoilValue(user);

  return (
    <div
      className={`
  ${borderClassName}
  ${borderColorClassName}
  rounded-xl flex  overflow-hidden flex-col box-border
  `}
    >
      <div style={{ height: headerHeight }} className='flex flex-col'>
        <MainHCell
          subTitle='Digital Only'
          title={plPlan ? getSubPlanName(plPlan?.name) : ''}
        />

        <HeaderCell
          bestValue={
            plPlan ? getStructuredPlanData(plPlan, userState).bestValue : false
          }
          disabled={
            plPlan ? getStructuredPlanData(plPlan, userState).disabled : false
          }
          title={plPlan ? getStructuredPlanData(plPlan, userState).title : ''}
          price={plPlan ? getStructuredPlanData(plPlan, userState).price : ''}
          priceCut='11,880'
          buttonTitle={
            plPlan ? getStructuredPlanData(plPlan, userState).buttonTitle : ''
          }
          buttonTooltip={
            plPlan ? getStructuredPlanData(plPlan, userState).buttonTooltip : ''
          }
          onClick={() => {
            setSelectedPlan(plPlan);
            plPlan &&
              subscriptionHandle(
                getStructuredPlanData(plPlan, userState).buttonTitle,
              );
          }}
          expText={
            plPlan ? getStructuredPlanData(plPlan, userState).expiresIn : ''
          }
        />
      </div>
      <div>
        <H1Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            ${borderT}
            ${borderB}
            `}
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
          title={
            plPlan ? getStructuredPlanData(plPlan, userState).whatInside : ''
          }
          classes={{
            pClass: 'text-center mx-0',
          }}
        />

        <H2Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={plPlan ? getStructuredPlanData(plPlan, userState).digital : ''}
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderB}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={plPlan ? getStructuredPlanData(plPlan, userState).hard : ''}
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={
            plPlan ? getStructuredPlanData(plPlan, userState).duration : ''
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={
            plPlan ? getStructuredPlanData(plPlan, userState).validity : ''
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title='Instantly Available'
          // icon={
          //   plPlan
          //     ? getStructuredPlanData(plPlan, userState).freeShipping
          //     : false
          // }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            ${borderR}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          icon={
            plPlan ? getStructuredPlanData(plPlan, userState).appAccess : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />
      </div>
    </div>
  );
};

export default SingleColumn;
